import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=5f981cee&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"
import style0 from "./Select.vue?vue&type=style&index=0&id=5f981cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f981cee",
  null
  
)

export default component.exports